import React, { createContext, ReactNode, useContext, useMemo, useState } from "react";

export type MatchHistoryContextData = {
  highlightPlayerNames: string[]
  setHighlightPlayerNames: (names: string[]) => void
  clearHighlightPlayerNames: () => void
};

const MatchHistoryContext = createContext<MatchHistoryContextData>({
  highlightPlayerNames: [],
  setHighlightPlayerNames: () => {},
  clearHighlightPlayerNames: () => {}
});

export type ProviderProps = {
  children: ReactNode
};

const MatchHistoryContextProvider: React.FC<ProviderProps> = ({ children }: ProviderProps) => {
  const [highlightPlayerNames, setHighlightPlayerNames] =
    useState<string[]>([]);

  const data = useMemo<MatchHistoryContextData>(() => ({
    highlightPlayerNames,
    setHighlightPlayerNames,
    clearHighlightPlayerNames: () => setHighlightPlayerNames([])
  }), [highlightPlayerNames]);

  return (
    <MatchHistoryContext.Provider value={data}>
      {children}
    </MatchHistoryContext.Provider>
  )
};

export default MatchHistoryContextProvider;

export const useMatchHistoryContext = () => useContext(MatchHistoryContext);
